import { render, staticRenderFns } from "./DetalleMovimiento.vue?vue&type=template&id=1d8d4259"
import script from "./DetalleMovimiento.vue?vue&type=script&lang=ts"
export * from "./DetalleMovimiento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports